import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import {
  AgColumnGroupHeaderComponent,
  AgColumnGroupHeaderExternalParams,
} from '@shared/ag-components/ag-column-group-header/ag-column-group-header';
import { decimalDivide } from '@shared/utils';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { Utils } from '@shared/utils/utils';

import {
  currencyFormatter,
  defaultHeaderClass,
  defaultMinWidth,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';

export const imaEvidenceBasedColumnGroup = (
  ctx: InMonthAdjustmentGridConfigContext
): ColGroupDef => {
  const { redirectFromEvidenceBasedColumn, shouldShowEvidenceColumns } = ctx.qcaComponent;

  if (!shouldShowEvidenceColumns()) {
    return {
      children: [],
    };
  }

  const evidenceBasedTooltip =
    'Check Investigator Transactions to access a list of recorded activities for the month. Please be aware that the displayed number on the screen might differ from the actual data due to lagging patient data';

  return {
    children: [
      getEvidenceBasedPercentageComponent(),
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        colId: 'evidence_based_unit',
        field: 'evidence_based_unit',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Monthly Units',
        headerTooltip: 'Monthly Units',
        minWidth: defaultMinWidth,
        valueFormatter: ({ value }) => Utils.decimalFormatter(value),
        width: 115,
        // aggFunc: showUnitTotals$.getValue() ? 'sum' : '',
      },
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        colId: 'evidence_based_amount',
        field: 'evidence_based_amount',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Monthly Expense ($)',
        headerTooltip: 'Monthly Expense ($)',
        minWidth: defaultMinWidth,
        valueFormatter: currencyFormatter,
        width: 160,
        // aggFunc: 'sum',
      },
    ],
    headerClass: [' blue-marker header-marker'],
    headerGroupComponent: AgColumnGroupHeaderComponent,
    headerGroupComponentParams: <AgColumnGroupHeaderExternalParams>{
      buttons: [
        {
          icon: 'Eye',
          onClick: redirectFromEvidenceBasedColumn,
          tooltip: evidenceBasedTooltip,
        },
      ],
      expansionDisabled: true,
    },
    headerName: 'Evidence Based',
    suppressStickyLabel: true,
  };
};

const getEvidenceBasedPercentageComponent = (): ColDef => {
  return {
    cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
    colId: 'evidence_based_percentage',
    field: 'evidence_based_percentage',
    filter: 'agNumberColumnFilter',
    headerClass: defaultHeaderClass,
    headerName: 'Monthly % Complete',
    headerTooltip: 'Monthly % Complete',
    minWidth: defaultMinWidth,
    valueFormatter: ({ value }) => Utils.percentageFormatter(decimalDivide(value, 100)),
    valueGetter: (params) => {
      // For Category/Group and Discount rows
      if (!params.data || params.data.cost_category_name === 'Discount') {
        const total_amount = params.data.total_amount;
        const evidence_based_amount = params.data.evidence_based_amount;

        return (evidence_based_amount / total_amount) * 100;
      }

      return params.data.evidence_based_percentage;
    },
    width: 135,
  };
};
